import Table from 'components/CncUI/Table';

const Head = ({ multiple, items }) => {
  const label = items.length > 1 && multiple ? 'Split Amount' : 'Amount';
  return (
    <Table.Head>
      <Table.Row>
        {multiple && <Table.Cell></Table.Cell>}
        {multiple && <Table.Cell>Priority</Table.Cell>}
        <Table.Cell>Bank Name</Table.Cell>
        <Table.Cell>Account Type</Table.Cell>
        <Table.Cell>Routing Number</Table.Cell>
        <Table.Cell>Account Number</Table.Cell>
        <Table.Cell>{label}</Table.Cell>
        <Table.Cell style={{ width: 44 }}> </Table.Cell>
      </Table.Row>
    </Table.Head>
  );
};

export default Head;
